import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer, validationsKey } from './validations-reducers';
import { EffectsModule } from '@ngrx/effects';
import { ValidationsEffects } from './validations-effects';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(validationsKey, reducer),
        EffectsModule.forFeature([ValidationsEffects])
    ]
})
export class ValidationsStoreModule {}
